<script>
import { defineComponent } from 'vue'
export default defineComponent({
    props: {
        title: { type: String, default: '' },

    },
    setup: (props, ctx) => {
        const onClickBack = () => {
            ctx.emit('clickBack');
        }

        return {
            onClickBack
        }
    },
})
</script>
<template>
    <div class="absolute top-0 left-0 w-full flex">
        <div class="max-width-page w-full m-auto flex relative topbar bg-white">
            <div class="text-center text-14 m-auto font-medium text-a-gray-4a4a4a">{{ title }}</div>
            <div class="absolute left-5 top-0 flex topbar">
                <img @click="onClickBack()" class="my-auto"  src="../../assets/icon/chevron-left-light.svg" />
            </div>
            
        </div>
    </div>
</template>
<style lang="scss" scoped>
    @import '../../style/base.scss';

    .topbar {
        height: $topbar-height;
    }
    .max-width-page {
        max-width: $max-width-mobile;
    }
</style>